<div class="smp-table-container">

    <div class="row no-gutters smp-table-header">
        <div class="col-sm-1 smp-table-column">
            {{ 'log.billing_log.label.source' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'log.billing_log.label.date' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'log.billing_log.label.duplicate' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'log.billing_log.label.user_name' | translate }}
        </div>

        <div class="col-sm-2 smp-table-column">
            {{ 'log.billing_log.label.case_no' | translate }}
        </div>

    </div>

    <div class="smp-table-rows-scrollable">

        <div class="row no-gutters smp-table-row" *ngFor="let log of logs">
            <div class="col-sm-1 smp-table-column center">
                {{ log.source }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.instant | drDateTime }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                <mat-icon *ngIf="log.duplicate">check</mat-icon>
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.user_name }}
            </div>

            <div class="col-sm-2 smp-table-column center">
                {{ log.smp_case_no }}
            </div>


        </div>

    </div>

</div>
